import { render, staticRenderFns } from "./AssetVideoGenerationInfo.vue?vue&type=template&id=089bb47c&lang=pug"
import script from "./AssetVideoGenerationInfo.vue?vue&type=script&lang=js"
export * from "./AssetVideoGenerationInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoGenerationInfo.vue?vue&type=style&index=0&id=089bb47c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports